<template>
  <div class="form-widget form-data-statistics form-text-input">
    <div class="widget-item">
      <x-proxy-form-item
        v-if="!widget.enableRule"
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="widget.readOnly"
      >
        <div class="refresh-box">
          <x-svg-icon
            v-if="renderSence !== 'ide'"
            :class="['refresh-icon', loading ? 'icon-loading' : '', 'pointer']"
            name="refresh-colorless"
            @click.native="handleRefresh"
          ></x-svg-icon>
        </div>
        <cube-input
          v-if="renderSence === 'ide'"
          :disabled="true"
          :placeholder="'实时统计'"
          :value="widget.defaultValue"
          :maxlength="widget.lengthLimit"
          :readonly="true"
          show-word-limit
          class="data-statistics-input"
        ></cube-input>
        <cube-input
          v-if="renderSence === 'edit'"
          v-model="formValue"
          :placeholder="'实时统计'"
          :disabled="true"
          :maxlength="widget.lengthLimit"
          show-word-limit
          :tabindex="tabindex"
          class="data-statistics-input"
        ></cube-input>
      </x-proxy-form-item>
      <x-proxy-form-item
        v-else
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validateKey="validateKey"
        :disabled="widget.readOnly"
      >
        <cube-input
          v-if="renderSence === 'ide'"
          :disabled="true"
          :placeholder="'实时统计'"
          :maxlength="widget.lengthLimit"
          :readonly="true"
          show-word-limit
          class="data-statistics-input"
        ></cube-input>
        <cube-input
          v-if="renderSence === 'edit'"
          :value="formValue"
          :disabled="true"
          :placeholder="'实时统计'"
          :maxlength="widget.lengthLimit"
          :readonly="true"
          show-word-limit
          :tabindex="tabindex"
          class="data-statistics-input"
        ></cube-input>
      </x-proxy-form-item>
    </div>
  </div>
</template>
<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import { mapAdapter } from '../form-build-action'

export default {
  name: 'FormDataStatistics',
  mixins: [FormWidgetConfigMixin],
  data() {
    return {
      refreshDebounce: this.$lodash.debounce((newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.localInitDataStatistics()
        }
      }, 500),
      unWatch: null,
      loading: false
    }
  },
  created() {
    this.unWatch = this.$watch(
      function() {
        if (
          this.widget.filterConditionGroupList &&
          this.widget.filterConditionGroupList.length > 0
        ) {
          const ruleComponentslist = []
          this.widget.filterConditionGroupList.forEach((condition) => {
            if (
              condition.selectorFilterConditionList &&
              condition.selectorFilterConditionList.length > 0
            ) {
              condition.selectorFilterConditionList.forEach((item) => {
                if (item.filterComponentId && item.filterComponentId.length > 0) {
                  item.filterComponentId.forEach((com) => {
                    ruleComponentslist.push(com)
                  })
                }
              })
            }
          })
          return (
            this.globalData &&
            this.globalData.ready +
              JSON.stringify(
                Object.keys(this.formData)
                  .filter((i) => ruleComponentslist.includes(i))
                  .map((one) => this.formData[one])
              )
          )
        }
        return this.globalData && this.globalData.ready + ''
      },
      (newVal, oldVal) => {
        if (newVal.startsWith('true')) {
          this.refreshDebounce(newVal, oldVal)
        }
      }
    )
  },
  beforeDestroy() {
    if (this.unWatch) {
      this.unWatch()
    }
  },
  methods: {
    ...mapAdapter(['initDataStatistics']),
    localInitDataStatistics() {
      setTimeout(() => {
        if (this.globalData && this.propKey && this.formData) {
          this.loading = true
          this.initDataStatistics(
            this.globalData.formId,
            this.globalData.documentId,
            [this.propKey],
            this.formData,
            (resp) => {
              setTimeout(() => {
                this.loading = false
              }, 500)
              if (resp.code === 'ok' && resp.data) {
                this.formValue = resp.data[this.propKey]
              }
            }
          )
        }
      }, 200)
    },
    handleRefresh() {
      this.localInitDataStatistics()
    }
  }
}
</script>
<style lang="scss">
@keyframes loading {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.form-data-statistics {
  .data-statistics-input {
    margin-right: 1.5rem;
  }
  .refresh-box {
    position: absolute;
    right: 0px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.43rem;
    height: 100%;
    .refresh-icon {
      color: $--app-notice-color;
      cursor: pointer;
      // &:hover {
      //   color: $--app-primary-color;
      // }
    }
  }
  .icon-loading {
    animation: loading 1s infinite linear;
  }
}
</style>
